import { Link } from "react-router-dom"
import styles from './LandingPage.module.css'
import { ChamUploadButton } from "../ChamUpload/ChamUpload";
import { ChamProjectsOpenButton } from "../ChamProjects/ChamProjects";
import luxe from './assets/luxe.svg';
import TopMenu from '../TopMenu/TopMenu';

export default function LandingPage() {

    return (
         <>
            <TopMenu extended={true} page="landing" />
            <section className={styles.landingSection}>
                <div className={styles.content}>
                    <div className={styles.cta}>
                        <img src={luxe} alt="Add a little Luxed to your home" />
                        <h2>Luxury vinyl flooring visualizer</h2>

                        <div className={styles.landingControls}>
                            <Link to="/roomscenes" className={styles.btnPrimary}>Get Started</Link>
                            {/* <ChamUploadButton title="Upload a Photo" className={styles.btnPrimary} /> */}
                            {/* <ChamProjectsOpenButton title="My Projects" className={styles.btnPrimary} /> */}
                        </div>
                    </div>
                </div>
            </section>
         </>
    )
}


